import React from 'react';
import styled from 'styled-components';
import search from '../../images/search.svg';
import notification from '../../images/notification.svg';
import user from '../../images/coffeee-logo-icon.svg';


const MainDiv = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background: #FFFFFF;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.1);
  padding: 0px 36px;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 4;
  box-sizing: border-box;
`;
const InputDiv = styled.div`
  position: relative;
  & img {
    height: 20px;
    width: 20px;
    position: absolute;
    top: 10px;
    left: 10px;
  }
  & input {
    height: 38px;
    width: 200px;
    padding: 0px 12px 0px 40px;
  }
`;
const NotificationDiv = styled.div`
  width: 36px;
  height: 32px;
  position: relative;
  margin: 0px 26px;
  & img {
    height: 24px;
    margin: 8px 14px 0px 0px;
  }
  & div {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    background-color: #FF5767;
    border-radius: 10px;
    padding: 3px 5px;
  }
`;
const UserImg = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 48px;
  overflow: hidden;
`;

const Header = () => {
  return (
    <MainDiv>
      <InputDiv>
        <img src={search} alt="search" />
        <input type="text" placeholder="Search" />
      </InputDiv>

      <NotificationDiv>
        <img src={notification} alt="notification" />
        <div>10</div>
      </NotificationDiv>

      <UserImg src={user} />
    </MainDiv>
  )
}

export default Header;
